/**
 * Handles inline header search field state.
 * Search submission uses Shopify's default search form behavior.
 */
class HeaderSearchInline extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form[data-search-form]');
    this.wrapper = this.closest('.header__search-inline-wrapper');
    this.header = this.closest('.header');
    this.searchToggle =
      this.header?.querySelector('.header__main-row-right .header__search .header__icon--search') ||
      this.header?.querySelector('.header__search .header__icon--search');
    this.searchDetails = this.searchToggle?.closest('details');
    this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    this.handleSearchToggleClick = this.handleSearchToggleClick.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);

    if (this.form) {
      this.initializeSearch();
    }
  }

  connectedCallback() {
    if (!this.searchToggle) return;

    this.searchToggle.addEventListener('click', this.handleSearchToggleClick);
    document.addEventListener('keydown', this.handleDocumentKeydown);
  }

  disconnectedCallback() {
    if (!this.searchToggle) return;

    this.searchToggle.removeEventListener('click', this.handleSearchToggleClick);
    document.removeEventListener('keydown', this.handleDocumentKeydown);
  }

  initializeSearch() {
    this.restoreSearchTermFromUrl();
  }

  handleSearchToggleClick(event) {
    if (!this.mobileMediaQuery.matches || !this.wrapper) return;

    event.preventDefault();
    this.searchDetails?.removeAttribute('open');

    if (this.wrapper.classList.contains('header__search-inline-wrapper--active')) {
      this.closeMobileSearch();
      return;
    }

    this.openMobileSearch();
  }

  handleDocumentKeydown(event) {
    if (event.key !== 'Escape' || !this.mobileMediaQuery.matches) return;

    this.closeMobileSearch();
  }

  openMobileSearch() {
    this.wrapper.classList.add('header__search-inline-wrapper--active');
    this.header?.classList.add('header--mobile-search-inline-open');
    this.searchToggle?.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(() => {
      this.form?.querySelector('input[name="q"]')?.focus();
    });
  }

  closeMobileSearch() {
    this.wrapper?.classList.remove('header__search-inline-wrapper--active');
    this.header?.classList.remove('header--mobile-search-inline-open');
    this.searchToggle?.setAttribute('aria-expanded', 'false');
  }

  restoreSearchTermFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q');

    if (!searchTerm) return;

    const searchInput = this.form.querySelector('input[name="q"]');
    if (searchInput) {
      searchInput.value = searchTerm;
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('header-search-inline', HeaderSearchInline);
